import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PageHeaderLargeComponent } from "./components/page-header/page-header-large/page-header-large.component";
import { PageFooterComponent } from "./components/page-footer/page-footer.component";
import { AlertWarningComponent } from "./components/alert-warning/alert-warning.component";
import { RouterModule } from "@angular/router";
import { UserProfileComponent } from "./components/user-profile/user-profile.component";
import { NgbDateAdapter, NgbDateParserFormatter, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PageHeaderSmallComponent } from "./components/page-header/page-header-small/page-header-small.component";
import { MainNavbarComponent } from "./components/main-menu/main-navbar/main-navbar.component";
import { MainDropdownComponent } from "./components/main-menu/main-dropdown/main-dropdown.component";
import { HeaderFooterLayout } from "./layouts/header-footer/header-footer.layout";
import { BillingGuard } from "./guards/billing.guard";
import { PoliciesGuard } from "./guards/policies.guard";
import { PaperlessBillingDeactivateGuard } from "./guards/paperless-billing-deactivate.guard";
import { PaperlessPolicyDeactivateGuard } from "./guards/paperless-policy-deactivate.guard";
import { LogoOnlyHeaderFooterLayout } from "./layouts/logo-only-header-footer/logo-only-header-footer.layout";
import { CustomNgbDateAdapter, CustomNgbDateParserFormatter } from "./providers/custom-ngb-date-picker";
import { ConfirmOneIncHandoffModalComponent } from './components/confirm-oneinc-handoff-modal/confirm-oneinc-handoff-modal.component';

@NgModule({
  declarations: [
    HeaderFooterLayout,
    PageHeaderLargeComponent,
    PageHeaderSmallComponent,
    PageFooterComponent,
    MainNavbarComponent,
    AlertWarningComponent,
    UserProfileComponent,
    MainDropdownComponent,
    LogoOnlyHeaderFooterLayout,
    ConfirmOneIncHandoffModalComponent,
  ],
  imports: [CommonModule, RouterModule, NgbModule],
  exports: [
    HeaderFooterLayout,
    LogoOnlyHeaderFooterLayout,
    PageHeaderLargeComponent,
    PageHeaderSmallComponent,
    PageFooterComponent,
    MainNavbarComponent,
    AlertWarningComponent,
    UserProfileComponent,
  ],
  providers: [
    BillingGuard,
    PoliciesGuard,
    PaperlessBillingDeactivateGuard,
    PaperlessPolicyDeactivateGuard,
    {
      provide: NgbDateAdapter, 
      useClass: CustomNgbDateAdapter
    },
    {
      provide: NgbDateParserFormatter, 
      useClass: CustomNgbDateParserFormatter
    }
  ],
})
export class CoreModule {}
